import React from 'react';

import LinkIcon from '@atlaskit/icon/core/link';

import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export type ThirdPartyIconProps = {
	/** Third-party ARI, e.g. "ari:third-party:google.google-drive::document/1" */
	thirdPartyId?: string | null;
};

/** Generic icon for a third-party (3P) Recent item, shown when there's no provider logo. */
export const ThirdPartyFallbackIcon = (): React.JSX.Element => <LinkIcon label="" />;

/**
 * The provider's logo for a 3P Recent item. Logos are lazy-loaded to keep them out of the
 * navigation bundle; the generic icon shows while they load and for unknown providers.
 */
export const ThirdPartyIcon: LoadableType<ThirdPartyIconProps> = LoadableLazy({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-ThirdPartyLogo" */ './ThirdPartyLogo.tsx'))
			.ThirdPartyLogo,
	loading: ThirdPartyFallbackIcon,
});
